<div>
    <div>{{msg}}</div>
    Try with other Client
    <input type="text" [(ngModel)]="clientName"/>
    <button (click)="onLogin()" [disabled]="clientName.length == 0" >Login</button>
</div>
